module.exports = __webpack_public_path__ + "static/08-02ddda4df047ee72b6d15efcf7ae282a.jpg";